import React from 'react'

const CampResultsSkeleton: React.FC = () => {
  return <span data-testid={'camp-results-skeleton'}>Searching your city...</span>
}

export default CampResultsSkeleton
